import { Navigate, Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function getStoredAccessToken() {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) return null;

  try {
    return JSON.parse(accessToken);
  } catch {
    return accessToken;
  }
}

export default function AdminOnlyRoute() {
  const location = useLocation();
  const accessToken = getStoredAccessToken();

  if (!accessToken) {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }

  try {
    const decoded = jwtDecode(accessToken);
    const now = Date.now() / 1000;

    if (decoded.exp < now) {
      return <Navigate to="/auth/login" replace state={{ from: location }} />;
    }

    if (![1, 3].includes(Number(decoded.roleId))) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
  } catch {
    return <Navigate to="/auth/login" replace state={{ from: location }} />;
  }
}
